export enum DateTimeFormat {
  USDate = 'MM-dd-yyyy',
  USDateSlashed = 'MM/dd/yyyy',
  ISODate = 'yyyy-MM-dd',
}

export const US_DATE_PLACEHOLDER_SLASHED = 'mm/dd/yyyy';
export const DEFAULT_DATE_FORMAT = DateTimeFormat.USDateSlashed;
